import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import { handleSubmit } from "../../../../auxiliar/auxFunctions";
import { isDefined } from "../../../../auxiliar/formatValidators";
import Dropdown from "./Dropdown";

const OptionSelector = ({ options }) => {
    return (
        <div className="flex items-center">
            <div
                className="flex rounded-lg bg-base-200 p-0.5"
                role="tablist"
                aria-orientation="horizontal"
            >
                {options &&
                    Object.values(options).map((o) => {
                        if (!o.condition) return null;

                        // n options in multiOption
                        const nOptions = isDefined(o.multiOption)
                            ? Object.values(o.multiOption).filter((o) => o.condition).length
                            : 0;

                        // if there's a multiOption with more than one option, show the dropdown
                        if (nOptions > 1) {
                            // Transform multiOption to dropdown items format
                            const dropdownItems = Object.values(o.multiOption)
                                .filter((mo) => mo.condition)
                                .map((mo) => ({
                                    key: mo.title.replace(/\s/g, ""),
                                    label: mo.title,
                                    onClick: handleSubmit(mo.onClick),
                                    disabled: mo.disabled,
                                    active: mo.selected,
                                }));

                            const triggerElement = (
                                <div
                                    className={`flex items-center justify-between rounded-md py-2 px-3 text-sm font-semibold transition-colors duration-200
                                    ${o.selected ? "bg-primary/15 shadow-sm cursor-pointer" : o.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:bg-primary/8"}`}
                                    title={
                                        o.disabled && isDefined(o.disabledInfo)
                                            ? o.disabledInfo
                                            : undefined
                                    }
                                >
                                    <div className="flex items-center">
                                        {o.icon && (
                                            <FontAwesomeIcon
                                                icon={o.icon}
                                                className={
                                                    !o.disabled
                                                        ? "text-secondary"
                                                        : "text-disabled-content"
                                                }
                                            />
                                        )}

                                        {o.title && (
                                            <span
                                                className={`hidden lg:flex lg:ml-2 ${!o.disabled ? "text-primary" : "text-disabled-content"}`}
                                            >
                                                {o.title}
                                            </span>
                                        )}
                                    </div>

                                    {/* Dropdown indicator */}
                                    <FontAwesomeIcon
                                        icon={faChevronDown}
                                        className={`ml-2 text-xs transition-transform duration-200 ${!o.disabled ? "text-primary/60" : "text-disabled-content"}`}
                                    />
                                </div>
                            );

                            return (
                                <Dropdown
                                    key={o.title}
                                    trigger={triggerElement}
                                    items={dropdownItems}
                                    position="bottom-right"
                                    width="w-52"
                                    disabled={o.disabled}
                                    centerDropdown={false}
                                    closeOnItemClick={true}
                                />
                            );
                        }

                        // if there's a single option or a multiOption with only one option, show the button
                        const mergedOption = {
                            title: o.title,
                            icon: o.icon,
                            selected: o.selected,
                            onClick:
                                nOptions !== 1
                                    ? o.onClick
                                    : Object.values(o.multiOption).filter((o) => o.condition)[0]
                                          .onClick,
                            disabled:
                                nOptions !== 1
                                    ? o.disabled
                                    : Object.values(o.multiOption).filter((o) => o.condition)[0]
                                          .disabled,
                        };

                        return (
                            <button
                                key={mergedOption.title}
                                disabled={mergedOption.disabled}
                                className={`flex items-center rounded-md py-2 px-3 text-sm font-semibold  ${mergedOption.selected ? "bg-primary/15 shadow-sm" : "hover:bg-primary/8"} cursor-pointer transition-colors duration-200`}
                                id="headlessui-tabs-tab-:r1rg:"
                                role="tab"
                                type="button"
                                aria-selected={mergedOption.selected}
                                tabIndex={mergedOption.selected ? "0" : "-1"}
                                data-headlessui-state={mergedOption.selected ? "selected" : ""}
                                aria-controls="headlessui-tabs-panel-:r1ri:"
                                onClick={handleSubmit(mergedOption.onClick)}
                            >
                                {mergedOption.icon && (
                                    <FontAwesomeIcon
                                        icon={mergedOption.icon}
                                        className={
                                            !mergedOption.disabled
                                                ? "text-secondary"
                                                : "text-disabled-content"
                                        }
                                    />
                                )}
                                {mergedOption.title && (
                                    <span
                                        className={`hidden lg:flex lg:ml-2 ${!mergedOption.disabled ? "text-primary" : "text-disabled-content"}`}
                                    >
                                        {mergedOption.title}
                                    </span>
                                )}
                            </button>
                        );
                    })}
            </div>
        </div>
    );
};

export default OptionSelector;
